// extracted by mini-css-extract-plugin
module.exports = {"button":"toggleButton_button__344ML","toggled":"toggleButton_toggled__1axTI"};